import type { ReservationSectionId } from '@/wabunka-src/common/features/Reservation/core/requiredFields/sections';
import { buildReservationSectionParams, type ReservationSectionParams } from '@/wabunka-src/common/utils/googleAnalytics/common/reservationSection';
import { sendWabunkaGAEvent } from '@/wabunka-src/common/utils/googleAnalytics/googleAnalytics';

export type ReservationSectionContinueParams = ReservationSectionParams;

/** 発火タイミング：新動線でセクションの Continue を押したとき。Edit で戻ってから押し直しても毎回送る */
export const sendGAWabunkaReservationSectionContinueEvent = (sectionId: ReservationSectionId) => {
  sendWabunkaGAEvent('reservation_section_continue', buildReservationSectionParams(sectionId));
};
